import "./choose-industry.css";
"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.function.name");

var _get2 = _interopRequireDefault(require("lodash/get"));

var _component = require("../../_utils/component");

var _vueNormalizeComponent = _interopRequireDefault(require("../../_utils/vue-normalize-component.js"));

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var __vue_script__ = {
  name: (0, _component.createComponentName)('choose-industry'),
  mixins: [_component.componentMixin],
  props: {
    allOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    chosenOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  data() {
    return {
      transformedOptions: this.transform(this.allOptions, this.chosenOptions)
    };
  },

  computed: {
    hasChosenOptions() {
      return this.chosenOptions && this.chosenOptions.length;
    }

  },
  watch: {
    chosenOptions(value) {
      this.transformedOptions = this.transform(this.allOptions, value);
    }

  },
  methods: {
    transform(all, chosen) {
      return all.map(function (option) {
        var value = chosen.find(function (chosenOption) {
          return chosenOption.preference_id === option.id;
        });

        if (value) {
          option.chosen = true;
        }

        return option;
      });
    },

    toggleChooseIndustry(item) {
      var type = '';

      if (item.chosen) {
        type = 'delete';
      } else {
        type = this.chosenOptions.length ? 'update' : 'create';
      }

      this.$emit('chooseOption', {
        id: item.id,
        recordId: (0, _get2.default)(this.chosenOptions, '[0].recordId'),
        chosen: !item.chosen,
        type
      });
    },

    showProfessionOptions() {
      this.$emit('showProfessionOptions');
    }

  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("section", {
    class: _vm.bem("", _vm.hasChosenOptions ? "has-chosen-options" : "")
  }, [_c("header", {
    class: _vm.bem("header")
  }, [_c("div", {
    class: _vm.bem("header-main")
  }, [_vm._v("仅需两步，就可获得更精准的模板推荐")]), _vm._v(" "), _c("div", {
    class: _vm.bem("header-sub")
  }, [_vm._v("您的行业是？")])]), _vm._v(" "), _c("main", [_c("ul", {
    class: _vm.bem("option-list")
  }, _vm._l(_vm.transformedOptions, function (option) {
    return _c("li", {
      key: option.id,
      class: _vm.bem("option-item"),
      on: {
        click: function click($event) {
          return _vm.toggleChooseIndustry(option);
        }
      }
    }, [_c("button", {
      class: [option.chosen ? "chosen" : "", _vm.bem("option-btn")]
    }, [_c("span", [_vm._v(_vm._s(option.name))])])]);
  }), 0)]), _vm._v(" "), _vm.chosenOptions && _vm.chosenOptions.length ? _c("footer", {
    class: _vm.bem("footer")
  }, [_c("button", {
    class: _vm.bem("next-btn"),
    on: {
      click: _vm.showProfessionOptions
    }
  }, [_c("span", [_vm._v("下一步")])])]) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

/* style inject */

/* style inject SSR */
var _default2 = (0, _vueNormalizeComponent.default)({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

exports.default = _default2;